

import React, { memo } from 'react';
import MultiValueAddon from '../../components/MultiValueAddon';














function disableOption(disabledValues) {
  return (option) => {
    if (disabledValues.includes(option.value)) {
      return { ...option, disabled: true };
    }
    return option;
  };
}

function disableOptions(options, disabledOptions) {
  if (!Array.isArray(disabledOptions) || !disabledOptions.length) return options;
  const disabledValues = disabledOptions.map((option) => option.value);
  return options.map(disableOption(disabledValues));
}

function SrtCaptions({
  srtCaptions,
  onChangeAddon,
  disabled,
  SRT_CAPTIONS,
  getCurrencySymbol,
  editingMode,
  disabledOptions,
  dropdownType,
  onCheckboxStateChange,
  showAboutInfo
}) {
  return (
    <MultiValueAddon
      name="SRT_CAPTIONS"
      options={disableOptions(SRT_CAPTIONS, disabledOptions)}
      addonValue={srtCaptions}
      title="Captions - SRT"
      subtitle="Spoken English videos only. Allow up to 48-72 hours."
      icon="transcribe"
      onChangeAddon={onChangeAddon('SRT_CAPTIONS')}
      disabled={disabled}
      dropdownType={dropdownType}
      getCurrencySymbol={getCurrencySymbol}
      editingMode={editingMode}
      addItemLabel="Additional Caption"
      onCheckboxStateChange={onCheckboxStateChange}
      showAboutInfo={showAboutInfo} />);


}

export default memo(SrtCaptions);